import Notices from '@/components/notices/Notices';
import AdminHeader from '../components/common/AdminHeader';
import PermissionGuard from '@/components/common/PermissionGuard';

export default function NoticesPage() {
    return (
        <div className="min-h-screen bg-gray-50">
            <AdminHeader />
            <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
                {/* <PermissionGuard screen=""> */}
                    <Notices />
                {/* </PermissionGuard> */}
            </main>
        </div>
    );
}
